module.exports = __webpack_public_path__ + "img/career1.34ec622f.png";